import mongoose from 'mongoose';
import schema, { IAnonymousAccessTokenDocument } from '../schemas/anonymous-access-token';

const AnonymousAccessToken = (mongoose.models.AnonymousAccessToken ||
  mongoose.model<IAnonymousAccessTokenDocument>('AnonymousAccessToken', schema)) as mongoose.Model<
  IAnonymousAccessTokenDocument
>;

export default AnonymousAccessToken;
